import React from "react";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

const BlogPageProfile = () => {
  const user = {
    social: [
      {
        label: "facebook",
        link: "https://www.facebook.com/guptaashwanee",
        icon: "fab fa-facebook-f",
        anchorClass: "fb-ic",
      },
      {
        label: "twitter",
        link: "https://www.twitter.com/guptaashwanee",
        icon: "fab fa-twitter",
        anchorClass: "tw-ic",
      },
      {
        label: "github",
        link: "https://www.github.com/guptaashwanee",
        icon: "fab fa-github",
        anchorClass: "git-ic",
      },
      {
        label: "dribbble",
        link: "https://www.dribbble.com/guptaashwanee",
        icon: "fab fa-dribbble",
        anchorClass: "dribbble-ic",
      },
      {
        label: "linkedIn",
        link: "https://www.linkedin.com/in/guptaashwanee/",
        icon: "fab fa-linkedin-in",
        anchorClass: "li-ic",
      },
      {
        label: "instagram",
        link: "https://www.instagram.com/guptaashwanee",
        icon: "fab fa-instagram",
        anchorClass: "ins-ic",
      },
    ],
  };
  return (
    <div className="card rounded-lg">
      <div
        style={{ width: "130px", height: "130px" }}
        className="avatar mx-auto mt-4 rounded-circle z-depth-1 blog-profile"
      >
        <img
          src="https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/users%2FBd3o0M0o1YUKVVoczU1AAkodnRO2.jpeg?alt=media&token=3cfce532-e352-4458-8e00-c7c07ec97ea3"
          className="rounded-circle img-fluid"
          alt="Ashwanee"
        />
      </div>

      <div className="card-body px-xl-5">
        <h4 className="dark-grey-text text-center py-1">
          <strong>Ashwanee Kumar Gupta</strong>
        </h4>
        <h6 className="card-title dark-grey-text text-center">
          <strong>Graphics Designer/Web Developer</strong>
        </h6>
        <p className="dark-grey-text text-center mb-1">
          <i className="fa fa-map-marker-alt" aria-hidden="true"></i> Rewa
          Madhya Pradesh, India
        </p>
        <p className="dark-grey-text text-center">
          <a
            className="text-center"
            aria-label="ashwanee gupta wwebsite"
            rel="noopener noreferrer"
            target="_blank"
            href="https://guptaashwanee.github.io"
          >
            guptaashwanee.github.io
          </a>
        </p>
        <div className="d-flex justify-content-around my-4">
          <Button
            style={{ borderRadius: 50 }}
            className="px-5 mr-2"
            variant="outlined"
          >
            Follow
          </Button>
          <Button
            style={{ borderRadius: 50 }}
            className="px-5 ml-2"
            variant="outlined"
          >
            Message
          </Button>
        </div>
        <div className="mb-3 text-center">
          {user.social.map((social) => (
            <Tooltip title={social.label} arrow placement="bottom">
              <a
                key={social.label}
                style={{ width: 35, height: 35, margin: "0.15rem" }}
                className={`btn-floating z-depth-1 btn-small`}
                aria-label={social.label}
                rel="noopener noreferrer"
                target="_blank"
                href={social.link}
              >
                <i
                  style={{ fontSize: "1rem", lineHeight: "35px" }}
                  className={social.icon + " " + social.anchorClass}
                ></i>
              </a>
            </Tooltip>
          ))}
        </div>
        <div className="blog-profile-table d-lg-flex justify-content-center">
          <table>
            <tr>
              <td>Followers</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Following</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Blogs</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Views</td>
              <td>0</td>
            </tr>
            <tr>
              <td>Likes</td>
              <td>0</td>
            </tr>
          </table>
        </div>

        <p className="font-weight-bold text-left mt-2 mb-1">About Me</p>

        <p className="mt-1 dark-grey-text font-small text-left">
          <em>
            Hello, I'm Ashwanee. An Engineering student. Interested in Web
            Development, Graphic Design and Motion Graphics.
          </em>
        </p>

        <p className="text-center">Member Since: September 29, 2020</p>
      </div>
    </div>
  );
};

export default BlogPageProfile;
